import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4badff14")

_pushScopeId("data-v-4badff14")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen right-container" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-start bg-primary-100 overflow-y-scroll px-12 pt-12" }
const _hoisted_4 = { class: "panel-container rounded-md bg-white pb-2 mb-16" }
const _hoisted_5 = { class: "flex items-center justify-between w-full table-header-color px-4 py-3" }
const _hoisted_6 = { class: "mr-2" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "新しい設定を登録", -1)
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "情報取得中...", -1)
const _hoisted_11 = { class: "hidden lg:flex justify-end items-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 選択した設定を削除 ")
const _hoisted_13 = { class: "mr-6 text-gray-500 text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_loading_icon = _resolveComponent("m-loading-icon")
  const _component_m_table = _resolveComponent("m-table")
  const _component_HearRateAlertSettingAddModal = _resolveComponent("HearRateAlertSettingAddModal")
  const _component_HeartRateAlertSettingEditModal = _resolveComponent("HeartRateAlertSettingEditModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: "心拍アラート管理",
          breadcrumbs: []
        }),
        _createVNode("main", _hoisted_3, [
          _createVNode("section", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
                  type: "search",
                  name: "searchMiniApp",
                  placeholder: "タイトルで検索...",
                  class: "w-44 md:w-60 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-2 leading-8 transition-colors duration-300"
                }, null, 512), [
                  [_vModelText, _ctx.searchKeyword]
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_m_button, {
                  color: "primary-500",
                  "hover-color": "primary-600",
                  onClick: _ctx.showAddModal
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, {
                      type: "plus",
                      width: "4",
                      class: "mr-2"
                    }),
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode(_component_m_loading_icon),
                  _hoisted_10
                ]))
              : (_openBlock(), _createBlock(_component_m_table, {
                  key: 1,
                  datas: _ctx.filteredHeartRateAlertSettingsForTable,
                  definitions: _ctx.tableDefinitions,
                  "count-per-page": 40,
                  "default-sort-key": "title",
                  editable: true,
                  selectable: "",
                  "selected-ids": [],
                  onChange: _ctx.onSelectionChange,
                  onSelect: _ctx.onSelectedForEdit
                }, {
                  footer: _withId(() => [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_m_button, {
                        color: "red-400",
                        "hover-color": "red-500",
                        outline: "",
                        class: "mr-6",
                        disabled: !_ctx.selectedSettingIds.length,
                        onClick: _ctx.deleteSelectedSettings
                      }, {
                        default: _withId(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode("p", _hoisted_13, _toDisplayString(_ctx.selectedSettingIds.length) + "個を選択中 ", 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["datas", "definitions", "onChange", "onSelect"]))
          ])
        ])
      ])
    ]),
    (_ctx.addModalShowing)
      ? (_openBlock(), _createBlock(_component_HearRateAlertSettingAddModal, {
          key: 0,
          students: _ctx.validStudents,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addModalShowing = false)),
          onExecute: _ctx.executeAdd
        }, null, 8, ["students", "onExecute"]))
      : _createCommentVNode("", true),
    (_ctx.editModalShowing && _ctx.selectedSetting)
      ? (_openBlock(), _createBlock(_component_HeartRateAlertSettingEditModal, {
          key: 1,
          students: _ctx.validStudents,
          setting: _ctx.selectedSetting,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editModalShowing = false)),
          onExecute: _ctx.executeEdit,
          onExecuteDelete: _ctx.deleteSelectedSetting
        }, null, 8, ["students", "setting", "onExecute", "onExecuteDelete"]))
      : _createCommentVNode("", true)
  ], 64))
})